import { render } from "./Driver.vue?vue&type=template&id=058562b2"
import script from "./Driver.vue?vue&type=script&lang=js"
export * from "./Driver.vue?vue&type=script&lang=js"
script.render = render

export default script